import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { MatPaginator, MatTableDataSource, MatSnackBar, PageEvent } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ClienteinfoService } from 'src/app/services/clienteinfo.service';

@Component({
  selector: 'app-fib-proactivos',
  templateUrl: './fib-proactivos.component.html',
  styleUrls: ['./fib-proactivos.component.scss']
})
export class FibProactivosComponent implements OnInit {

  public agente: any;
  pageSize = 8;
  FILTER: string = null;
  
  estadosEntrada = [
    { value: null, label: 'Todos' },
    { value: 1, label: 'Candidato a Contactar' },
    { value: 2, label: 'Primer Contacto Enviado' },
    { value: 3, label: 'Segundo Contacto Enviado' },
    { value: 4, label: 'Tercer Contacto Enviado' },
    { value: 5, label: 'Cuarto Contacto Telefónicamente' },
    { value: 6, label: 'Cliente Acepta Visita y Agenda' },
    { value: 7, label: 'Técnico Asignado Visita en Curso' },
    { value: 8, label: 'Cerrado' },
    { value: 9, label: 'Cliente No Acepta Visita' }
  ];
  
  grupoValFIBProactivos = new FormGroup({
    filtro: new FormControl(''),
    telefono: new FormControl(''),
    cuenta: new FormControl(''),
    falla: new FormControl(''),
    estado_entrada: new FormControl(null)
  });

  reporteColumnsFIBProactivos: string[] = [];
  dataSourceFIBProactivos = new MatTableDataSource<any>([]);
  allFIBProactivosData: any[] = []; // Almacenar todos los datos originales
  resultsLengthFIBProactivos: number = 0;

  @ViewChild('fibproactivosPaginator') fibproactivosPaginator: MatPaginator;
  @ViewChild('fibProactivosTable') fibProactivosTable: any;

  constructor(
    public pageTitle: ComponentPageTitle,
    private gateway: GatewayService,
    private spinner: NgxSpinnerService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private clienteinfo: ClienteinfoService
  ) {
    this.agente = this.localSave.get('usuarioPGV');
  }

  ngOnInit() {
    this.pageTitle.title = 'Proactivos';
    // Cargar datos al inicializar
    this.getFIBProactivos(0);
  }

  trackByColumn(index: number, column: string): string {
    return column;
  }

  getDisplayedColumns(): string[] {
    // Vista supervisor: solo TELEFONO y columnas dinámicas (sin ACCION)
    return ['TELEFONO', ...this.reporteColumnsFIBProactivos];
  }

  formatColumnName(column: string): string {
    // Convertir nombres de columnas a formato legible
    // Ejemplo: 'acct_contact_phone1' -> 'ACCT CONTACT PHONE1'
    return column.replace(/_/g, ' ').toUpperCase();
  }

  public isDateColumn(column: string): boolean {
    // Detectar si una columna es de tipo fecha (excluyendo solo horas)
    const dateKeywords = ['fecha', 'date', 'inicio', 'fin', 'final', 'cleared'];
    const excludeKeywords = ['notification_count', 'count', 'time', 'tiempo']; // Excluir columnas que no son fechas
    const columnLower = column.toLowerCase();
    
    // Excluir si contiene palabras clave de exclusión
    if (excludeKeywords.some(keyword => columnLower.includes(keyword))) {
      return false;
    }
    
    // Incluir si contiene palabras clave de fecha
    return dateKeywords.some(keyword => columnLower.includes(keyword));
  }

  public isTimeOnlyValue(value: any): boolean {
    // Verificar si el valor es solo una hora (no una fecha completa)
    if (!value) {
      return false;
    }
    
    if (typeof value === 'string') {
      // Patrón para detectar solo hora: HH:mm:ss o HH:mm
      const timeOnlyPattern = /^\d{1,2}:\d{2}(:\d{2})?$/;
      return timeOnlyPattern.test(value.trim());
    }
    
    return false;
  }

  public cambioElementosFIBProactivos(event?: PageEvent) {
    this.getFIBProactivos(event.pageIndex);
  }

  generarFIBProactivos() {
    if (this.fibproactivosPaginator) {
      this.fibproactivosPaginator.firstPage();
    }
    this.getFIBProactivos(0);
  }

  getFIBProactivos(page) {
    if (page == 0) {
      if (this.fibproactivosPaginator) {
        this.fibproactivosPaginator.firstPage();
      }
    }
    
    let estadoEntradaSeleccionado = this.grupoValFIBProactivos.controls.estado_entrada.value;
    // Si es null, no incluir estado_entrada (no filtrar por estado en supervisor)
    let estadoEntradaNumero = estadoEntradaSeleccionado 
      ? (Array.isArray(estadoEntradaSeleccionado) ? estadoEntradaSeleccionado[0] : estadoEntradaSeleccionado)
      : null;

    let params: any = {
      page: page,
      pageSize: this.pageSize,
      sortBy: "Cuenta",
      sortOrder: "ASC"
    };

    // Agregar estado_entrada solo si hay selección
    if (estadoEntradaNumero !== null) {
      params.estado_entrada = estadoEntradaNumero;
    }

    // Agregar filtros solo si tienen valor
    let telefono = this.grupoValFIBProactivos.controls.telefono.value;
    let cuenta = this.grupoValFIBProactivos.controls.cuenta.value;
    let falla = this.grupoValFIBProactivos.controls.falla.value;
    let nombre = this.FILTER || this.grupoValFIBProactivos.controls.filtro.value;

    if (telefono) params.telefono = telefono;
    if (cuenta) params.cuenta = cuenta;
    if (falla) params.falla = falla;
    if (nombre) params.nombre = nombre;
    this.spinner.show();
    
    this.gateway.get('listarContacto', params).then((result: any) => {
      let contactos = result.rows || [];
      
      // Si el resultado tiene una estructura diferente, ajustar aquí
      if (!contactos || contactos.length === 0) {
        this.dataSourceFIBProactivos = new MatTableDataSource([]);
        this.resultsLengthFIBProactivos = 0;
        // Llamar al conteo incluso si no hay datos
        this.gateway.get('listarContactoCount', params).then((result: any) => {
          this.resultsLengthFIBProactivos = result.rows[0].total;
          this.spinner.hide();
        }).catch((e) => {
          this.spinner.hide();
        });
        return;
      }
      
      
      // Si no hay columnas definidas, intentar obtenerlas del primer elemento
      if (this.reporteColumnsFIBProactivos.length === 0 && contactos.length > 0) {
        // Obtener todas las claves del primer objeto
        let columnas = Object.keys(contactos[0]);
        // Filtrar TELEFONO, idcliente y variantes para no duplicar columna explícita ni mostrar idcliente en tabla
        columnas = columnas.filter(key =>
          !['TELEFONO', 'Telefono', 'telefono', 'acct_contact_phone1', 'ACCT_CONTACT_PHONE1', 'phone', 'PHONE', 'phone1', 'PHONE1', 'idcliente', 'IDCLIENTE', 'IdCliente'].includes(key)
        );
        // NO agregar ACCION aquí porque se define estáticamente en el HTML
        this.reporteColumnsFIBProactivos = [...columnas]; // Crear nueva referencia del array
      }
      
      // Asignar datos directamente al dataSource
      this.dataSourceFIBProactivos = new MatTableDataSource(contactos);
      
      
      // Forzar detección de cambios después de generar columnas y actualizar dataSource
      this.cdr.detectChanges();
      
      // Esperar un ciclo de renderizado
      setTimeout(() => {
        // Forzar recálculo del layout de la tabla
        if (this.fibProactivosTable) {
          this.fibProactivosTable.updateStickyColumnStyles();
        }
        this.cdr.detectChanges();
      }, 100);
      
      // Llamar al endpoint de conteo DENTRO del .then() de listarContacto
      this.gateway.get('listarContactoCount', params).then((result: any) => {
        this.resultsLengthFIBProactivos = result.rows[0].total;
        this.spinner.hide(); // Ocultar spinner solo cuando ambas llamadas terminen
      }).catch((e) => {
        this.spinner.hide();
      });
    }
    ).catch((e) => {
      this.spinner.hide();
      this.snackbar.open('Error al cargar los datos de FIB Proactivos.', 'Cerrar', { duration: 3000 });
    });
  }

  applyFIBProactivosFilter() {
    this.FILTER = this.grupoValFIBProactivos.controls.filtro.value || '';
    if (this.fibproactivosPaginator) {
      this.fibproactivosPaginator.firstPage();
    }
    this.getFIBProactivos(0);
  }

  llamarFIBProactivo(element) {
    this.spinner.show();

    const telefono = element.TELEFONO || element.Telefono || element.telefono || element.acct_contact_phone1;
    const idcliente = element.idcliente != null ? element.idcliente : (element.IDCLIENTE != null ? element.IDCLIENTE : element.IdCliente);
    const idcampana = 199;

    if (!telefono) {
      this.snackbar.open('No se encontró número de teléfono.', 'Cerrar', { duration: 5000 });
      this.spinner.hide();
      return;
    }
    if (idcliente == null || idcliente === undefined) {
      this.snackbar.open('No se encontró idcliente para este contacto.', 'Cerrar', { duration: 5000 });
      this.spinner.hide();
      return;
    }

    const clienteactivo = {
      idcliente: idcliente,
      telefono: telefono,
      idcampana: idcampana
    };
    const campana = { idcampana: idcampana };
    this.clienteinfo.setcliente(clienteactivo, campana, this.localSave.get('usuarioPGV').idagente);

    this.localSave.set('clienteFromFIB', true);
    this.router.navigate(['homeagente/atencioncliente'])
      .then((e) => {
        this.spinner.hide();
      });
  }
}

